export function createGemmaSceneWorker(): Worker {
  return new Worker(new URL('./gemma-scene-worker.ts', import.meta.url), {
    type: 'module',
  })
}
